import { render, staticRenderFns } from "./purposeGroupSingle.vue?vue&type=template&id=7495fda5&scoped=true"
import script from "./purposeGroupSingle.vue?vue&type=script&lang=js"
export * from "./purposeGroupSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495fda5",
  null
  
)

export default component.exports